import { OnDestroy, Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { CultureFacade } from '../cultures/facade/cultures.facade';

@Pipe({ name: 'prepareHtml', standalone: true })
export class PrepareHtmlPipe implements PipeTransform, OnDestroy {
  private cultureService = inject(CultureFacade);
  private sanitizer = inject(DomSanitizer);

  private sub: Subscription;
  private activeCulture: string;

  private readonly hrefPattern: RegExp =
    /(<a[^>]+href=")(\/.*?"[^>]*>.*?<\/a>)/gm;

  constructor() {
    this.sub = this.cultureService
      .getActiveCulture()
      .subscribe((activeCulture) => (this.activeCulture = activeCulture));
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  transform(html?: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.addCulture(html ?? ''));
  }

  addCulture(html: string): string {
    const modifiedHtml = html?.replace(
      this.hrefPattern,
      (match, prefix, linkContent) => {
        const cultureRegex = new RegExp(`^\\/(${this.activeCulture})`);
        const cultureToAdd = `/${this.activeCulture}`;

        if (!cultureRegex.test(linkContent)) {
          // Check if the culture is already present at the beginning with or without a preceding "/"
          if (
            linkContent.startsWith(cultureToAdd) ||
            linkContent.startsWith(`/${cultureToAdd}`)
          ) {
            return match; // No need to add the culture as it's already present
          } else {
            return `${prefix}${cultureToAdd}${linkContent}`;
          }
        } else {
          return match; // The culture is already present, return the original match
        }
      },
    );

    return modifiedHtml;
  }
}
